import { ControlValueAccessor } from '@angular/forms';
import { ChangeDetectorRef, inject } from '@angular/core';
import { Constructor } from '../types';

export function ControlValueAccessorMixin<T, F>(Component:  Constructor<F> | Function) {
  const MixinComponent = class extends (Component as Constructor) implements ControlValueAccessor {

    public value: T = null;
    public isDisabled = false;

    public onChange: Function = () => {};
    public onTouched: Function = () => {};
    public readonly cdr = inject(ChangeDetectorRef);

    public writeValue(obj: T): void {
      this.value = obj;
      this.cdr.detectChanges();
    }

    public registerOnChange(fn: Function): void {
      this.onChange = fn;
    }

    public registerOnTouched(fn: Function): void {
      this.onTouched = fn;
    }

    public propagateChanges(data: T): void {
      this.onChange(data);
      this.onTouched(data);
      this.cdr.detectChanges();
    }

    public setDisabledState(isDisabled: boolean): void {
      this.isDisabled = isDisabled;
      this.cdr.detectChanges();
    }
  };

  return MixinComponent as typeof MixinComponent & Constructor<F>;
}
